import { FC, useEffect, useMemo, useRef, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import DataTable from 'react-data-table-component'
import { fetchData, toasterrormsg } from '../../../reusable'
import { KTIcon } from '../../../_metronic/helpers'
import Loader from '../component/Loader'
import { PageTitle } from '../../../_metronic/layout/core'
import Select from 'react-select'
import { Link } from 'react-router-dom'
import { Modal } from 'react-bootstrap'
import { Tr } from '../../../_metronic/i18n/Tr'
import moment from 'moment'

const ViewHelpAndSupport: FC = () => {

  const t = Tr()
  var vendorId = "";
  const vendorData = sessionStorage.getItem("vendor");
  if (vendorData) {
    var vendor = JSON.parse(vendorData);
    vendorId = vendor.vendorId;
  } else {
    console.log("No vendor data found");
  }
  const [offset, setOffset] = useState(0)
  const [limit, setLimit] = useState(5)
  const [supportList, setSupportList] = useState([])
  const [totalRecords, setTotalRecords] = useState('') as any
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState('')
  const [statusList] = useState([
    { label: 'All', value: '' },
    { label: 'In Progress', value: '0' },
    { label: 'Resolved', value: '1' },
    { label: 'Rejected', value: '2' },
  ])
  const [status, setStatus] = useState('')
  const [description, setDescription] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [showInfo, setShowInfo] = useState(false);
  const handleCloseInfo = () => setShowInfo(false);
  const handleShowInfo = () => setShowInfo(true);

  //  revenue list api call
  const supportListApiCall = async (
    limit1?: any,
    offset1?: any,
  ) => {
    setIsLoading(true)
    var param: any = {
      vendorId: String(vendorId),
      limit: limit1,
      offset: offset1,
      status: status,
      search: searchTerm
    }
    var res = await fetchData('public/viewsupport', param)
    if (res.status == '200') {
      setIsLoading(false)
      var data = res.data
      setSupportList(data.data)
      setTotalRecords(data.totalRecords)
    } else {
      toasterrormsg(res.message)
    }
  }

  const handlePageChange = (newPage: number) => {
    const newOffset = (newPage - 1) * limit;
    setOffset(newOffset);
    supportListApiCall(limit, newOffset);
  };

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setLimit(newRowsPerPage);
    supportListApiCall(newRowsPerPage, offset);
  };
  // search Data
  const searchData = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)
  }

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {

      // Focus on the input element when the onchange event is triggered
      await props.fnserch(e, 1)
      // inputRef.current.focus();
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])
    return (
      <div className='d-flex justify-content-between flex-wrap w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div className='d-flex flex-wrap'>
          <Select
            name='status'
            id='status'
            placeholder={t('Select')}
            isSearchable={true}
            isClearable={true}
            options={statusList}
            value={statusList.find(
              (option: any) => option.value == status
            ) || ""}
            onChange={(e: any) => { setStatus(e ? e.value : ''); }}
          />
        </div>
      </div>
    )
  }

  // Define your DataTable columns
  var column = useMemo(
    () => [
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('#')}</label>),
        cell: (row: any, index: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {index + 1}
            </div>
          </div>
        ),
        selector: (row: any, index: any) => index + 1, // Add 1 to start from 1 instead of 0
        width: '50px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Ticket ID')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.supportCode != '' ? '#' + row.supportCode : '-'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.supportCode),
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Status')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            {row.status == 0 ? (
              <span className='badge badge-warning mx-2'>{t('In Progress')}</span>
            ) : row.status == 1 ? (
              <span className='badge badge-success mx-2'>{t('Resolved')}</span>
            ) : row.status == 2 ? (
              <span className='badge badge-light-danger mx-2'>{t('Rejected')}</span>
            ) : (
              <div className='fw-bold fs-5'>-</div>
            )}
          </div>
        ),
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Subject')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.subject != '' ? row.subject : '-'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.subject),
        filter: true,
        width: '250px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Message Preview')}</label>),
        cell: (row: any) => (
          <button
            className='btn btn-sm text-primary fw-bold text-hover-primary text-start p-0'
            onClick={() => {
              setDescription(row.description)
              handleShowInfo();
            }}
          >
            <div className='fw-bold fs-5 text-truncate w-250px'>
              {row.description != '' ? row.description : '-'}
            </div>
          </button>
        ),
        sortable: true,
        selector: (row: any) => String(row.description),
        filter: true,
        width: '250px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Date Submitted')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.created != '' ? moment(row.created).format('YYYY-MM-DD HH:mm') : '-'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.created),
        filter: true,
        width: '250px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Last Response')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.lastResponse != '' ? row.lastResponse : '-'}
            </div>
          </div>
        ),
        filter: true,
        width: '250px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Action')}</label>),
        cell: (row: any) => (
          <>
            <Link to={'#'} className='text-success me-2 fs-6'>View</Link> / <Link to={'#'} className='text-success ms-2 fs-6'>Reply 🗨️</Link>
          </>
        ),
        filter: true,
        width: '250px',
      },
    ],
    [t]
  )
  useEffect(() => {
    supportListApiCall(limit, offset)
  }, [searchTerm, status])

  return (
    <>
      {isLoading && <Loader />}
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t('View Help & Support')}</PageTitle>
      <div className="d-flex justify-content-end my-2">
        <Link
          className='btn bg-white btn-active-light-primary cursor-pointer'
          style={{ color: 'rgb(24, 28, 50)' }}
          to="../addhelpandsupport/"
        >
          + {t('Add Help & Support Request')}
        </Link>
      </div>
      {
        <div className="card card-flush py-4">
          <div className="card-body pt-0">
            <DataTable
              columns={column}
              data={supportList}
              pagination
              paginationServer={true}
              subHeader={true}
              subHeaderComponent={
                <CustomHeader search={searchTerm} isfoc={focus} fnserch={searchData} />
              }
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handleRowsPerPageChange}
              paginationTotalRows={totalRecords}
              paginationPerPage={limit}
              paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
            />
          </div>
        </div>
      }
      <Modal
        show={showInfo}
        onHide={handleCloseInfo}
        backdrop="static"
        keyboard={false}
      >
        <div className="modal fade show" id="kt_modal_upload" tabIndex={-1} style={{ display: "block" }} aria-modal="true" role="dialog">
          {/* <!--begin::Modal dialog--> */}
          <div className="modal-dialog modal-dialog-centered mw-700px">
            {/* <!--begin::Modal content--> */}
            <div className="modal-content">
              {/* <!--begin::Form--> */}
              <div className="form" id="kt_modal_upload_form">
                {/* <!--begin::Modal header--> */}
                <div className="modal-header d-flex justify-content-between border-bottom border-1 border-success">
                  {/* <!--begin::Modal title--> */}
                  <h2 className="fw-bold">{t('Description')}</h2>
                  {/* <!--end::Modal title--> */}
                  {/* <!--begin::Close--> */}
                  <div className="btn btn-icon btn-sm btn-active-icon-primary" onClick={handleCloseInfo}>
                    <i className="ki-duotone ki-cross fs-1"><span className="path1"></span><span className="path2"></span></i>
                  </div>
                  {/* <!--end::Close--> */}
                </div>
                {/* <!--end::Modal header--> */}
                {/* <!--begin::Modal body--> */}
                <div className="modal-body pt-10 pb-15 px-lg-17">
                  <div className="row text-break">
                    {
                      description &&
                      <div>{description}</div>
                    }
                    {
                      !description &&
                      <label className='form-label text-muted text-center'>{t('No Description Found')}</label>
                    }
                  </div>
                </div>
                {/* <!--end::Modal body--> */}
              </div>
              {/* <!--end::Form--> */}
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export { ViewHelpAndSupport }
